export default function ColorPicker({ color, onChange }: { color: string, onChange: (color: string) => void }) {
    const colors = ["#000", "#f28500", "#612F74", "#c0c0c0", "#091475"];
    return <div className="flex flex-row gap-1">
        {colors.map((c, index) => <div key={index} onClick={() => onChange(c)} className={`w-6 h-6 rounded-md cursor-pointer`} style={{ backgroundColor: c }}></div>)}
    </div>
}